import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Alert from 'react-bootstrap/Alert';
import Container from 'react-bootstrap/Container';
import { t } from '../../../i18n';
import { Loader } from '../../../components';
import { loadCoursesProfileInformation } from './redux/actions';
import { getProfileState } from '../../selectors';
import useCurrentUser from '../../current-user/useCurrentUser';
import GreetingsBlock from './components/greetings';
import ProfileCoursesCarousel from '../../components/profile-courses-carousel/index';
import SummaryBlock from './components/summary';
import CourseVideoModal from '../../components/course-video-modal';
import LineLoader from '../../components/line-loader';
import './styles.scss';

const ProfileScreen = () => {
  const [currentVideo, setCurrentVideo] = useState(null);
  const { currentUser } = useCurrentUser();

  const dispatch = useDispatch();
  const { data, isLoading, hasError } = useSelector(getProfileState);

  useEffect(() => {
    dispatch(loadCoursesProfileInformation());
  }, []);

  const handlePlayVideo = video => {
    setCurrentVideo(video);
  };

  if (isLoading || !currentUser) {
    return (
      <div className="profile-screen profile-screen__loading-indication-wrapper">
        <LineLoader hide={!isLoading} className="profile-screen__line-loader" />
        <Loader />
      </div>
    );
  }

  if (hasError) {
    return <Alert variant="danger">{t('SERVER_ERROR')}</Alert>;
  }

  return (
    <Container fluid className="profile-screen">
      <GreetingsBlock userName={currentUser.name} />
      <SummaryBlock
        userName={currentUser.name}
        userEmail={currentUser.email}
        userPhotoUrl={currentUser.photoAltSizes.photo256x256}
        completedCoursesTotal={data.completedCoursesDataSource.length}
        activeCoursesTotal={data.activeCoursesDataSource.length}
        trainingHoursTotal={data.totalHoursOfTraining}
      />
      <div className="profile-screen__purchased-courses-block">
        <ProfileCoursesCarousel
          topTitle={t('DIGITAL_COURSES.PROFILE_SCREEN.PURCHASED_COURSES.TOP_TITLE')}
          mainTitle={t('DIGITAL_COURSES.PROFILE_SCREEN.PURCHASED_COURSES.MAIN_TITLE')}
          allCourses={data.allCoursesDataSource}
          activeCourses={data.activeCoursesDataSource}
          completedCourses={data.completedCoursesDataSource}
          notStartedCourses={data.notStartedCoursesDataSource}
          onPlayCoursePreview={handlePlayVideo}
          isLoading={false}
        />
      </div>
      <CourseVideoModal visible={!!currentVideo} video={currentVideo} onClose={() => setCurrentVideo(null)} />
    </Container>
  );
};

export default ProfileScreen;
